import { rootDomain } from './env';

function isLocalhost(hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.localhost');
}

/**
 * The store reads this cookie to authorize test payments, so it has to cross from
 * the dashboard origin to the store origin.
 *
 * On instance dev stacks both run on localhost ports, where `domain=.checkoutpage.dev`
 * fails domain-match and the cookie is dropped entirely. A host-only cookie reaches
 * both, since ports don't scope cookies. It has to drop `secure`/`samesite=None`
 * with the domain, which Safari and Firefox refuse over plain http.
 */
export function buildAuthCookie(value, maxAge) {
  const base = `auth_token=${value}; max-age=${maxAge}; path=/`;

  if (isLocalhost(window.location.hostname)) {
    return base;
  }

  return `${base}; domain=.${rootDomain}; secure; samesite=None`;
}

export function clearAuthCookie() {
  return buildAuthCookie('', 0);
}
